
import {
    defineComponent,
    provide,
    ref
} from "vue"
import ViewFile from "./ViewFile.vue"

export default defineComponent({
    props: {
        view: {
            type: String,
            required: true,
            default: "rectangle",
        },
        files: {
            type: Array,
            required: true,
            default: []
        }
    },
    components: {
        ViewFile
    },
    setup() {
        const urlFile = ref('')
        const open_dialog_view_file = ref(false)

        //variables open modal
        provide('urlFile', urlFile)
        provide('open_dialog_view_file', open_dialog_view_file)

        const openViewFile = (item) => {
            urlFile.value = item
            open_dialog_view_file.value = true
        }

        return {
            urlFile,
            open_dialog_view_file,
            openViewFile
        }
    }
})
